import { useAppDispatch } from '@/shared/lib/redux'
import { IBooking } from '@/shared/api/aviabooking'
import { openTicketsModal } from '../model/booking-payment-slice'

export const useBookingTicketsModal = () => {
    const dispatch = useAppDispatch()

    const openModal = (booking: IBooking) => {
        dispatch(openTicketsModal({
            booking,
        }))
    }
    
    return {
        openModal,
    }
}